import { ProfileSteps } from '../services';

export const INIT_PROFILE_STEPS: ProfileSteps = {
  profile: 'Profile',
  family: 'Family',
  questionnaire: undefined,
  decisionSupport: undefined,
  chatSupport: undefined,
};

export const DECISION_SUPPORT_PAGES = [
  'bundled_benefits',
  'decisioniq',
  'decision_support',
  'jellyvision',
];

export const INIT_CATEGORIES = [
  'category_1',
  'category_2',
  'category_3',
  'category_4',
];

export const PROFILE_FOOTERS_IN_ORDER = [
  'profile',
  'family',
  'questionnaire',
  'decisioniq',
  'decision_support',
];
export const DETAILS_IN_ORDER = [
  'beneficiaries',
  'e_sign',
  'eoi',
  'documents',
  'carrier_communications',
];

export const ALL_FOOTERS_IN_ORDER = [
  PROFILE_FOOTERS_IN_ORDER,
  INIT_CATEGORIES,
  'details',
  DETAILS_IN_ORDER,
  'confirm',
].flat();

export const ENROLLMENT_STATUS_STORAGE_KEY = 'enrollmentLatest';
